import type { IEventVaultResponseV1 } from "@/types"
import { Location } from "@/models"

export enum WelcomeInvitationPageMode {
  LIVE = "Live",
  INVITATION = "Invitation",
  FREEMIUM = "Freemium",
}

export interface IInvitationResponse {
  invitationId?: number
  title?: string
  invitationMessage?: string
  rsvpMessage?: string
  rsvpDate?: Date
  callToActionMessage?: string
  rsvpEnabled?: boolean
  rsvpEmailEnabled?: boolean
  allowSongRequests?: boolean
  allowDietaryRequirements?: boolean
  allowPublicGuestList?: boolean
}

export interface IWelcomeInvitationResponse {
  pageMode?: WelcomeInvitationPageMode
  eventVault?: Partial<IEventVaultResponseV1 & { timeZone?: string }>
}

export class WelcomeInvitation {
  public pageMode?: WelcomeInvitationPageMode
  public eventVaultID?: number
  public eventDate?: Date
  public eventEndDate?: Date
  public timezone?: string
  public location?: Location
  public title?: string
  public message?: string
  public rsvpMessage?: string
  public rsvpDate?: Date
  public ctaMessage?: string
  public rsvpEnabled?: boolean
  public rsvpEmailEnabled?: boolean
  public allowSongRequests?: boolean
  public allowDietaryRequirements?: boolean
  public allowPublicGuestList?: boolean

  constructor(welcomeInvitation: Partial<WelcomeInvitation>) {
    this.pageMode = welcomeInvitation.pageMode
    this.eventVaultID = welcomeInvitation.eventVaultID
    this.eventDate = welcomeInvitation.eventDate
    this.eventEndDate = welcomeInvitation.eventEndDate
    this.timezone = welcomeInvitation.timezone
    this.location = welcomeInvitation.location
    this.title = welcomeInvitation.title
    this.message = welcomeInvitation.message
    this.rsvpMessage = welcomeInvitation.rsvpMessage
    this.rsvpDate = welcomeInvitation.rsvpDate
    this.ctaMessage = welcomeInvitation.ctaMessage
    this.rsvpEnabled = welcomeInvitation.rsvpEnabled
    this.rsvpEmailEnabled = welcomeInvitation.rsvpEmailEnabled
    this.allowSongRequests = welcomeInvitation.allowSongRequests
    this.allowDietaryRequirements = welcomeInvitation.allowDietaryRequirements
    this.allowPublicGuestList = welcomeInvitation.allowPublicGuestList
  }

  public static fromResponse(response?: IWelcomeInvitationResponse) {
    return new WelcomeInvitation({
      pageMode: response?.pageMode,
      eventVaultID: response?.eventVault?.eventVaultId,
      eventDate: response?.eventVault?.eventDate ? new Date(response?.eventVault?.eventDate) : undefined,
      eventEndDate: response?.eventVault?.eventEndDate ? new Date(response?.eventVault?.eventEndDate) : undefined,
      timezone: response?.eventVault?.timeZone,
      location: response?.eventVault?.location ? Location.fromResponseV1(response?.eventVault?.location) : undefined,
      title: response?.eventVault?.invitation?.title,
      message: response?.eventVault?.invitation?.invitationMessage,
      rsvpMessage: response?.eventVault?.invitation?.rsvpMessage,
      rsvpDate: response?.eventVault?.invitation?.rsvpDate,
      ctaMessage: response?.eventVault?.invitation?.callToActionMessage,
      rsvpEnabled: response?.eventVault?.invitation?.rsvpEnabled,
      rsvpEmailEnabled: response?.eventVault?.invitation?.rsvpEmailEnabled,
      allowSongRequests: response?.eventVault?.invitation?.allowSongRequests ?? false,
      allowDietaryRequirements: response?.eventVault?.invitation?.allowDietaryRequirements ?? false,
      allowPublicGuestList: response?.eventVault?.invitation?.allowPublicGuestList ?? false,
    })
  }
}
